import axios from "axios";

export const state = {
    savings: [],
};

export const getters = {
    savings: (state) => state.savings,
};

export const mutations = {
    setSavings(state, newValue) {
        state.savings = newValue;
    },
};

export const actions = {
    async fetchSavings({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/savings/${fyear}`).then((res) => {
            commit("setSavings", res.data.savings);
        });
    },
    async filterSavings({ commit }, { datefrom, dateto }) {
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtersavings";
        await axios.post(url, formData).then((response) => {
            commit("setSavings", response.data.savings);
        });
    },
};
